import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CurrencyProvider } from "@/context/CurrencyContext";
import LandingPage from "@/pages/LandingPage";
import CheckoutPage from "@/pages/CheckoutPage";
import ThankYouPage from "@/pages/ThankYouPage";
import AboutPage from "@/pages/AboutPage";
import PrivacyPage from "@/pages/PrivacyPage";
import SupportPage from "@/pages/SupportPage";
import ReviewPage from "@/pages/ReviewPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import InstallPrompt from "@/components/InstallPrompt";
import AnnouncementBar from "@/components/AnnouncementBar";

/**
 * Bare /admin → send the user to the right place based on auth state.
 * (Authenticated → dashboard. Unauthenticated → login.)
 * Token validity is re-checked by adminApi on the next request; if it's
 * expired the dashboard handler will bounce back to /admin/login.
 */
function AdminEntryRedirect() {
  const hasToken =
    typeof window !== "undefined" &&
    !!window.localStorage?.getItem("aigl_admin_token");
  return <Navigate to={hasToken ? "/admin/dashboard" : "/admin/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <BrowserRouter>
          <AnnouncementBar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/checkout/:productId" element={<CheckoutPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/admin" element={<AdminEntryRedirect />} />
            <Route path="/admin/" element={<AdminEntryRedirect />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            {/* Catch-all — never render a blank page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </CurrencyProvider>
    </div>
  );
}

export default App;
